/**
 * Real "how it works" process steps — verbatim from the live site's
 * #kako-funkcionise section. Note: the BS subtitle literally says "Tri
 * koraka" (three steps) but the section has always shown 4 steps — a
 * real copy bug on the live site. The EN dictionary already silently
 * fixed it to "Four steps", so that correction is used for both languages
 * here rather than reproducing the BS typo (resolved this same way in the
 * prior Phase 3 session per app/handoff.md).
 */

export interface ProcessStep {
  id: string
  num: number
  title: string
  titleEn: string
  desc: string
  descEn: string
}

export const PROCESS_STEPS: ProcessStep[] = [
  {
    id: 'contact',
    num: 1,
    title: 'Kontakt',
    titleEn: 'Contact',
    desc: 'Pišete mi na WhatsApp ili Viber — ispričate šta vam treba, ja slušam i postavljam prava pitanja.',
    descEn: 'You message me on WhatsApp or Viber — tell me what you need, I listen and ask the right questions.',
  },
  {
    id: 'design',
    num: 2,
    title: 'Dizajn & plan',
    titleEn: 'Design & plan',
    desc: 'Dogovaramo izgled, strukturu i sadržaj. Dobijate konkretan prijedlog s cijenom — bez iznenađenja.',
    descEn: 'We agree on the look, structure and content. You get a concrete proposal with pricing — no surprises.',
  },
  {
    id: 'development',
    num: 3,
    title: 'Razvoj',
    titleEn: 'Development',
    desc: 'Gradim stranicu po dogovorenom planu. Pratite napredak, dajete povratne informacije, ja unosim izmjene.',
    descEn: 'I build the site according to the agreed plan. You track progress, give feedback, I make changes.',
  },
  {
    id: 'launch',
    num: 4,
    title: 'Lansiranje',
    titleEn: 'Launch',
    desc: 'Stranica ide online. Dobijate sve pristupne podatke i kratki vodič — i tu sam ako ikad zatrebam.',
    descEn: 'The site goes live. You get all access credentials and a short guide — and I\u2019m here if you ever need me.',
  },
]
